// 2026-09-23 · Helper para limpiar localStorage preservando las claves
// del QR cliente (`tmoQr:*`). El código legacy hace `localStorage.clear()`
// en múltiples flujos (init session, receive hub, 401, logout) cuando
// detecta que no hay `userId` — pensado para limpiar tras logout admin,
// pero se dispara también cuando el visitante del QR no está logueado
// (correcto, es guest) → borraba `tmoQr:comensal:{idSession}` y en la
// siguiente recarga el auto-register creaba un comensal nuevo.
//
// Uso: sustituir cualquier `localStorage.clear()` que se ejecute en
// código que puede correr con un cliente QR activo.

const TMO_QR_PREFIX = "tmoQr:";

export function clearLocalStoragePreservingQr() {
  try {
    const preserved = {};
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith(TMO_QR_PREFIX)) {
        preserved[key] = window.localStorage.getItem(key);
      }
    }
    window.localStorage.clear();
    Object.entries(preserved).forEach(([k, v]) =>
      window.localStorage.setItem(k, v),
    );
  } catch {
    // Fallback conservador: si algo va mal enumerando, dejamos el
    // storage tal cual — mejor no perder datos del QR.
  }
}

export default clearLocalStoragePreservingQr;
